const CheckedIconCheckBox = (props) => {
  const { disabled } = props;
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17 2H7C4.2 2 2 4.2 2 7v10c0 2.8 2.2 5 5 5h10c2.8 0 5-2.2 5-5V7c0-2.8-2.2-5-5-5Z"
        fill={disabled ? "#D8D8DC" : "#009FFF"}
      />
      <path
        d="M10.3 16.2c-.2 0-.4-.1-.6-.2l-2.4-2.3c-.3-.3-.3-.8 0-1.2.3-.3.9-.3 1.2 0l1.8 1.8L15.7 9c.3-.3.9-.3 1.2 0 .3.3.3.9 0 1.2l-6 5.8c-.2.1-.4.2-.6.2Z"
        fill="#fff"
      />
    </svg>
  );
};

export default CheckedIconCheckBox;
